<template>
    <popup-modal-confirm
        :confirm-text="$t('applications.submit_change_source', { count: bulkCount})"
        :has-close-button="true"
        :title="$t('applications.change_source')"
        confirm-button="success"
        @close="$emit('close')"
        @confirm="changeSource"
        :disabled="!canSubmit"
        :working="working"
    >
        <loading v-if="!bulkKeyData"/>
        <div v-else>
            <select-dropdown
                v-model="form.source"
                add-new
                allow-enter
                allow-similar
                :auto-translate="false"
                class="cursor-text w-full min-h-32"
                enable-when-no-options
                :options="sources"
                searchable
                @new="addNew"
            />
        </div>
    </popup-modal-confirm>
</template>

<script>
import Loading from './Loading.vue';
import SelectDropdown from '../forms/SelectDropdown.vue';
import * as applications from '../../services/ApplicationService';
import * as bulkApplicationKey from '../../services/BulkApplicationKeyService';
import PopupModalConfirm from './PopupModalConfirm';
import Form from '../../etc/forms/Form';
import { ADD_NOTIFICATION } from '../../state/mutation-types';
import {mapActions} from 'pinia';
import {useNotificationsStore} from '../../state/modules/notifications';

export default {
    components: {
        'popup-modal-confirm': PopupModalConfirm,
        'loading': Loading,
        'select-dropdown': SelectDropdown,
    },
    props: {
        requestFilters: Object,
        applications: Array,
        stages: Array,
    },
    data: function () {
        return {
            working: false,
            bulkKeyData: null,
            sources: null,
            form: new Form([
                {name: 'source', value: ""}
            ]),
        };
    },
    computed: {
        bulkCount() {
            if (!this.bulkKeyData) {
                return 0;
            }

            return this.bulkKeyData.attributes.applications_count;
        },
        canSubmit() {
            return this.form.source;
        },
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        getBulkKey() {
            this.form.submit(data => bulkApplicationKey.get({
                    data: {
                        selection: {
                            applications: this.applications,
                            stages: this.stages,
                        }
                    },
                }, this.requestFilters),
            ).then(data => this.bulkKeyData = data);
        },
        changeSource() {
            this.working = true;
            applications.massUpdateSource(this.requestFilters, {
                applications: this.applications,
                stages: this.stages,
            }, this.bulkKeyData.id, {source: this.form.source}).then((result) => {
                if (result?.data?.message === 'started') {
                    this[ADD_NOTIFICATION]({
                        type: 'success',
                        message: this.$t('bulkaction.application.massUpdateSource.started'),
                    });
                    this.working = false;
                    this.$emit('close');
                    return;
                }

                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('applications.notification_change_source'),
                });
                this.working = false;
                this.$emit('close');
            })
        },
        addNew(value) {
            this.sources.push({
                label: value,
                value: value,
            });
        },
    },
    mounted() {
        this.getBulkKey();
        applications.sources().then(result => {
            this.sources = result.data.map(val => (val.referrer_source !== "Other" && {
                value: val.referrer_source,
                label: val.referrer_source,
            }));
        });
    }
}
</script>
